/**
 * Parse Effective Date from UI (MM/DD/YYYY) or ISO (YYYY-MM-DD) for the API.
 */
export function parseEffectiveDateInput(value) {
  const raw = String(value ?? '').trim();
  if (!raw) {
    return { ok: false, error: 'Effective date is required.' };
  }
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    return { ok: true, iso: raw, display: formatUs(raw) };
  }
  const slash = raw.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (slash) {
    const mm = slash[1].padStart(2, '0');
    const dd = slash[2].padStart(2, '0');
    const yyyy = slash[3];
    const iso = `${yyyy}-${mm}-${dd}`;
    const d = new Date(`${iso}T12:00:00`);
    if (Number.isNaN(d.getTime()) || d.getUTCMonth() + 1 !== Number(mm) || d.getUTCDate() !== Number(dd)) {
      return { ok: false, error: 'Invalid date. Use MM/DD/YYYY (e.g. 03/19/2026).' };
    }
    return { ok: true, iso, display: `${mm}/${dd}/${yyyy}` };
  }
  const dash = raw.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
  if (dash) {
    return parseEffectiveDateInput(`${dash[1]}/${dash[2]}/${dash[3]}`);
  }
  return { ok: false, error: 'Use MM/DD/YYYY (e.g. 03/19/2026).' };
}

function formatUs(iso) {
  const [y, m, d] = iso.split('-');
  return `${m}/${d}/${y}`;
}

/** Auto-format digits into MM/DD/YYYY while typing. */
export function maskUsDateInput(value) {
  const digits = String(value).replace(/\D/g, '').slice(0, 8);
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
}
